import React, { useEffect, useState, useRef } from 'react';
import './ListTypeModule.scss';
import { usePrevious } from '@uidotdev/usehooks';
import { Icon } from '../../icon/icon';

const ListTypeModule = ({ items }) => {
  const listTypeModuleRef = useRef();
  const [typeModuleCurrent, setTypeModuleCurrent] = useState('1');
  const prevTypeModule = usePrevious(typeModuleCurrent);

  const [showExpand, setShowExpand] = useState(false);
  const [listTypeModules, setListTypeModules] = useState([
    { key: '1', title: 'A' },
    { key: '11', title: 'D' },
    { key: '111', title: 'AS' },
    { key: '1111', title: 'Ư' },
    { key: '12', title: 'B' },
    { key: '121', title: 'AD' },
    { key: '1211', title: 'X' },
    { key: '13', title: 'G' },
  ]);

  const handleWheelScroll = (e, curRef) => {
    const container = curRef.current;
    if (e.deltaY > 0) {
      container.scrollLeft += e.deltaY / 5;
    } else {
      container.scrollLeft -= Math.abs(e.deltaY / 5);
    }
  };

  useEffect(() => {
    if (listTypeModules) {
      const check = listTypeModules.find(
        item => item.key === typeModuleCurrent
      );
      if (check === undefined) {
        setTypeModuleCurrent(listTypeModules[0]?.key);
      }
    }
  }, [typeModuleCurrent]);

  const id = Date.now();

  return (
    <div className="container-group">
      <div
        id={'group-option' + id}
        className={`group-row ${showExpand ? 'group-wrap' : ''}`}
        ref={listTypeModuleRef}
        onWheel={e =>
          handleWheelScroll && handleWheelScroll(e, listTypeModuleRef)
        }
      >
        {(items ?? listTypeModules).map((typeModule, typeIdx) => {
          return (
            <button
              key={typeIdx}
              // key={typeIdx}
              id={typeModule.key + id}
              className={`custom-button ${
                typeModuleCurrent === typeModule.key ? 'chip-active' : ''
              }`}
              onClick={() => {
                setTypeModuleCurrent(typeModule.key);

                const buttonType = document.getElementById(typeModule.key + id);

                if (buttonType) {
                  const container = buttonType.parentElement;
                  const containerRect = container.getBoundingClientRect();
                  const buttonRect = buttonType.getBoundingClientRect();

                  const scrollLeft = container.scrollLeft;
                  const containerCenter =
                    containerRect.left + containerRect.width / 2;
                  const buttonCenter = buttonRect.left + buttonRect.width / 2;

                  container.scrollTo({
                    left: scrollLeft + buttonCenter - containerCenter,
                    behavior: 'smooth',
                  });
                }
              }}
            >
              {typeModule.title}
            </button>
          );
        })}
      </div>

      <button
        className={`btn-more-type ${
          showExpand ? 'btn-more-type-expanded' : ''
        }`}
        onClick={() => {
          setShowExpand(!showExpand);

          if (showExpand === true) {
            const buttonType = document.getElementById(typeModuleCurrent);

            setTimeout(() => {
              if (buttonType) {
                const container = buttonType.parentElement;
                const containerRect = container.getBoundingClientRect();
                const buttonRect = buttonType.getBoundingClientRect();

                const scrollLeft = container.scrollLeft;
                const containerCenter =
                  containerRect.left + containerRect.width / 2;
                const buttonCenter = buttonRect.left + buttonRect.width / 2;

                container.scrollTo({
                  left: scrollLeft + buttonCenter - containerCenter,
                  // behavior: "smooth",
                });
              }
            }, 10);
          }
        }}
      >
        <div className="w-18 h-18 flex">
          <Icon.ICExpandMore />
        </div>
      </button>
    </div>
  );
};

export default ListTypeModule;
